import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  refreshKey: 0,
  MFrefreshKey: 0,
  FGrefreshKey: 0,
  BPrefreshKey: 0,
  CIrefreshKey: 0,
  PRrefreshKey: 0,
};

const refreshSlice = createSlice({
  name: "refresh",
  initialState,
  reducers: {
    triggerRefresh: (state) => {
      state.refreshKey += 1;
    },
    MFtriggerRefresh: (state) => {
      state.MFrefreshKey += 1;
    },
    FGtriggerRefresh: (state) => {
      state.FGrefreshKey += 1;
    },
    BPtriggerRefresh: (state) => {
      state.BPrefreshKey += 1;
    },
    CItriggerRefresh: (state) => {
      state.CIrefreshKey += 1;
    },
    PRtriggerRefresh: (state) => {
      state.PRrefreshKey += 1;
    },
  },
});

export const { triggerRefresh, MFtriggerRefresh, FGtriggerRefresh, BPtriggerRefresh, CItriggerRefresh, PRtriggerRefresh } = refreshSlice.actions;
export default refreshSlice.reducer;
